/**
 * cancellationSettingsSlice — Cancellation & Refund Policy settings.
 *
 * Hydrated from the live cancellation-settings API via
 * CancellationSettingsInitializer (seeded server-side by
 * `getCancellationSettingsSSR()`); the form seeds its local state from here and
 * dispatches `setCancellationSettings` with the server-returned value on save.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  type CancellationSettings,
  defaultCancellationSettings,
} from "@/components/settings/cancellation/types";

export interface CancellationSettingsState {
  settings: CancellationSettings;
  loading: boolean;
}

const initialState: CancellationSettingsState = {
  settings: defaultCancellationSettings(),
  loading: true,
};

const cancellationSettingsSlice = createSlice({
  name: "cancellationSettings",
  initialState,
  reducers: {
    /** Replace the cancellation settings — used to hydrate on mount and on save. */
    setCancellationSettings(
      state,
      action: PayloadAction<CancellationSettings>,
    ) {
      state.settings = action.payload;
    },
    setCancellationLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setCancellationSettings, setCancellationLoading } =
  cancellationSettingsSlice.actions;

export default cancellationSettingsSlice.reducer;
